import { useEffect, useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, List, ListItemButton, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Edit, MoreVert, VisibilityOffOutlined } from '@mui/icons-material';
import { IconDownload, IconFiles, IconPhotoEdit, IconTrash } from '@tabler/icons';

import { useDispatch, useSelector } from 'store';
import { activeItem, openDrawer } from 'store/slices/menu';

// custom css style
const projectItemContainerStyle = {
    borderRadius: '16px',
    padding: '12px 24px',
    marginLeft: '48px',
    cursor: 'pointer'
};

const userActionItemContentStyle = {
    display: 'flex',
    alignItems: 'center'
};

const ProjectNavItem = ({ projectInfo, handleProjectEdit, handleProjectArchive }) => {
    const { workspaceId, projectId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [mouseEnter, setMouseEnter] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickEdit = (id) => {
        handleClose();
        handleProjectEdit(id);
    }

    const handleClickArchive = (id) => {
        handleClose();
        handleProjectArchive(id);
    }
    
    return (
        <ListItemButton
            sx={{
                '&.MuiListItemButton-root': {
                    borderRadius: '16px',
                    marginLeft: '48px',
                    padding: '12px 24px',
                    '&.Mui-selected': {
                        bgcolor: '#FEFEFE !important'
                    },
                    '&:hover': {
                        bgcolor: '#FEFEFE !important'
                    }
                }
            }}
            selected={projectInfo.id === projectId}
            onMouseEnter={() => setMouseEnter(true)}
            onMouseLeave={() => setMouseEnter(false)}
            onClick={() => {
                navigate(projectInfo.url)
                dispatch(activeItem(null))
            }}
        >
            <ListItemText
                primary={
                    <Typography
                        variant={projectInfo.id === projectId ? 'h5' : 'body1'}
                        sx={{
                            fontSize: '14px',
                            fontWeight: 700,
                            fontFamily: 'Gilroy-Bold',
                            color: projectInfo.id === projectId || mouseEnter ? '#5A1C70' : '#2D3648',
                            '&:hover': {
                                color: '#5A1C70'
                            }
                        }}
                    >
                        {projectInfo.title}
                    </Typography>
                }
            />
            {projectInfo.isOwner && (
                <Box sx={{ ...userActionItemContentStyle, position: 'relative', zIndex: 10, width: '20px' }}>
                    <MoreVert
                        id="layer-action"
                        sx={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '5px',
                            alignSelf: 'center',
                            opacity: projectInfo.id === projectId || mouseEnter ? 1 : 0,
                        }}
                        onClick={handleClick}
                    />
                    <Menu
                        id="action-menu"
                        anchorEl={anchorEl}
                        open={menuOpen}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button'
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                handleClickEdit(projectInfo.id)
                            }}
                        >
                            <Edit
                                sx={{
                                    width: '20px',
                                    height: '20px',
                                    marginRight: '16px',
                                    color: '#2D3648',
                                    cursor: 'pointer'
                                }}
                            />
                            <FormattedMessage id="project-menu-option-edit" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                handleClickArchive(projectInfo.id);
                            }}
                        >
                            <IconTrash size="18px" color="#FF0000" style={{ marginRight: '16px' }} /> 
                            <FormattedMessage id="project-menu-option-delete" />
                        </MenuItem>
                    </Menu>
                </Box>
            )}
        </ListItemButton>
    );
};

export default ProjectNavItem;
